import React from 'react';
import FontAwesome from 'react-fontawesome';
import styled from 'styled-components';
import Theme from '../modules/Theme';
var SIZES = {
  fontSize: {
    small: '30px',
    medium: '45px'
  },
  padding: {
    small: '0 10px 0 10px',
    medium: '5px 10px 5px 10px'
  },
  lineHeight: {
    small: '10px',
    medium: '20px'
  }
};

var fontSize = function fontSize(size) {
  return SIZES.fontSize[size] || '60px';
};

var padding = function padding(size) {
  return SIZES.padding[size] || '10px';
};

var lineHeight = function lineHeight(size) {
  return SIZES.lineHeight[size] || '40px';
};

var SectionIcon = styled(function (_ref) {
  var className = _ref.className,
      name = _ref.name;
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement(FontAwesome, {
    name: name
  }));
}).withConfig({
  displayName: "SectionIcon",
  componentId: "lgj77f-0"
})(["float:left;color:", ";font-size:", ";padding:", ";line-height:", ";"], function (props) {
  return props.color ? props.color : Theme.primary;
}, function (props) {
  return fontSize(props.size);
}, function (props) {
  return padding(props.size);
}, function (props) {
  return lineHeight(props.lineHeight);
});
export default SectionIcon;